import axios from 'axios';

import { env } from 'config';
import {
  ConfigValidationResult,
  CreateDynamicAdapterConfigDto,
  DynamicAdapterConfig,
  DynamicPayinConfig,
  DynamicPayoutConfig,
  PaginatedData,
  QueryParams,
} from 'types';
import { apiUtils } from 'utils';

const url = `${env.apiUrl}/dynamic-adapter-configs`;

export const dynamicAdapterConfigsApi = {
  getAll: async (): Promise<DynamicAdapterConfig[]> =>
    (await axios.get(url)).data,

  getAllPaginated: async (
    params?: Partial<QueryParams>,
  ): Promise<PaginatedData<DynamicAdapterConfig>> =>
    (await apiUtils.getWithQueryParams(`${url}/paginated`, params)).data,

  getOne: async (id: string): Promise<DynamicAdapterConfig> =>
    (await axios.get(`${url}/${id}`)).data,

  create: async (
    data: CreateDynamicAdapterConfigDto,
  ): Promise<DynamicAdapterConfig> => (await axios.post(url, data)).data,

  update: async ({
    id,
    data,
  }: {
    id: string;
    data: Partial<CreateDynamicAdapterConfigDto>;
  }): Promise<DynamicAdapterConfig> =>
    (await axios.patch(`${url}/${id}`, data)).data,

  remove: async (id: string): Promise<void> =>
    (await axios.delete(`${url}/${id}`)).data,

  activate: async (id: string): Promise<DynamicAdapterConfig> =>
    (await axios.post(`${url}/${id}/activate`)).data,

  deactivate: async (id: string): Promise<DynamicAdapterConfig> =>
    (await axios.post(`${url}/${id}/deactivate`)).data,

  validate: async (id: string): Promise<ConfigValidationResult> =>
    (await axios.post(`${url}/${id}/validate`)).data,

  validateJson: async (data: {
    payinConfig?: DynamicPayinConfig;
    payoutConfig?: DynamicPayoutConfig;
  }): Promise<ConfigValidationResult> =>
    (await axios.post(`${url}/validate-json`, data)).data,

  clone: async (id: string, name: string): Promise<DynamicAdapterConfig> =>
    (await axios.post(`${url}/${id}/clone`, { name })).data,
};
